import { FeedbacksApi } from "@/api/feebacks";
import { QueryKey } from "@/utils";
import { useInfiniteQuery } from "@tanstack/react-query";

const PER_PAGE = 20;

export const useGetFeedbacks = (searchQuery?: string) => {
  const { data, isPending, error, refetch, fetchNextPage } = useInfiniteQuery({
    queryKey: [QueryKey.FEEDBACKS, searchQuery],
    queryFn: ({ pageParam }: { pageParam: number }) => {
      return FeedbacksApi.getUnhandledFeedbacks({
        perPage: PER_PAGE,
        page: pageParam,
        search: searchQuery,
      });
    },
    refetchInterval: 30000,
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const nextPage = lastPage.meta.page + 1;
      return nextPage <= lastPage.meta.totalPages ? nextPage : undefined;
    },
    select: ({ pages }) => {
      const data = pages.flatMap(({ data }) => data);
      const meta = pages[0].meta;

      return { meta, data };
    },
  });

  return {
    feedbacks: data,
    feedbacksError: error,
    isFeedbacksLoading: isPending,
    refetchFeedbacks: refetch,
    fetchNextFeedbackPage: fetchNextPage,
  };
};
